export const CANDIDATE_KEY_UPDATE_PARTICULAR = 'CANDIDATE_KEY_UPDATE_PARTICULAR';
export const CANDIDATE_KEY_GET_PARTICULAR = 'CANDIDATE_KEY_GET_PARTICULAR';
